import { Link } from "react-router-dom";
import { BackgroundImage } from "react-image-and-background-image-fade";

import { config } from 'config';
import {useContext} from "react";
import {AppContext} from "../../../contexts/AppContext";

const SlideItem = ({category_id, category_name, image_path, description}) => {
    const dataLang = useContext(AppContext)
    return (
        <div className="item">
            <div
                className="movie type-movie status-publish has-post-thumbnail hentry movie_genre-action movie_genre-adventure movie_genre-drama">
                <div className="gen-carousel-movies-style-3 movie-grid style-3">
                    <div className="gen-movie-contain">
                        <div className="gen-movie-img">
                            <img
                                src={`${config.cloudfront_image_category}/${encodeURI(image_path)}`}
                                className="gen-movie-image"
                                alt=""
                            />   
                            <div className="gen-movie-action">
                                <Link to={`/category/${category_id}`} className="gen-button">
                                    <i className="fa fa-play"></i>
                                </Link>
                            </div>
                        </div>
                        <div className="gen-info-contain">
                            <div className="gen-movie-info">
                                <h3>
                                    <Link to={`/category/${category_id}`}>{ dataLang.langSpanish ? category_name : description }</Link>
                                </h3>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SlideItem;
